module.exports = __webpack_public_path__ + "static/Donald-52767a6d20aaee48872081c7f513eacf.jpg";